/**
 * Configuraciones comunes, no suele ser necesario reemplazarlas
 * Si es necesario modificar alguna de estas configuraciones, hacerlo en environment.custom.ts
 */

export const common = {
  // otros enlaces
  brandNameLink: 'https://vivofacil.com',
  serviceChat: 'https://asistencia.vivofacil.com',
  videoCallsUrl: 'https://videollamada.vivofacil.com/?kid=AljJRe39SLEsWhMFg2pqTrA',
  complaintsChannel: 'https://vivofacil.com/es/content/24-canal-de-denuncias',
  veterinaryVideoCallsUrl: 'https://calendly.com/vivofacil/videoconsulta-veterinaria',
  veterinaryChat: 'https://widget-page.smartsupp.com/widget/b16a399a78a713e02ac2fd696824ab65bdd1ad7c',


  /**
   * Debe existir la cadena de traducción de cada item
   */
  protectedPeople: {
    empleado: 'protectedPeople.employee',
    pareja: 'protectedPeople.partner',
    hijos: 'protectedPeople.offspring',
    padres: 'protectedPeople.parents',
    suegros: 'protectedPeople.inlaws'
  },

  /**
   * Contraseña por defecto utilizada cuando no hay registro y el usuario no tiene que meter contraseña
   */
  defaultPassword: 'nopassword',

  /**
    * Recaptcha en formularios
    * Si los formularios van protegidos con recaptcha sobreescribir esta variable
    * dándole el valor de la clave pública
    * Valores: false|<clave_publica>
  */
  recaptcha: false,

  /** Se agrupan los servicios por categorías */
  groupByCategories: true,

  /** Se permiten contraseñas no seguras */
  allowInsecurePasswords: true,

  /** numero de teléfono o false. Si es false no se muestra el icono de whatsapp en las páginas */
  whatsapp: false,

  /** true of false. Define si se muestra el botón para volver al inicio */
  homeButton: false,

  /** Mostrar botón de contacto en cabecera */
  headerContactButton: true,

  /** Mostrar banner de contacto en cabecera */
  contactBanner: true,

  /** Mostrar url */
  externalTopLinkUrl: false,

  /** Se añade la cadena `/xxxxx` a la url del enlace adicional, donde xxxxx es el identificador del usuario en base64 */
  externalTopLinkConcatIdentifier: false,
};
